import { createQueryClient } from '@repo/query';

export const queryClient = createQueryClient({
  staleTime: 1000 * 60 * 5,
  gcTime: 1000 * 60 * 10,
  retry: 1,
  refetchOnWindowFocus: false,
});
